<template>
  <div>
    <Row>
      <Col span="12">
        <Form
          ref="form"
          :model="formItem"
          :rules="formRules"
          :label-width="120"
        >
          <form-header name="基本信息" label="权限组基本信息"></form-header>
          <FormItem label="名称" prop="title">
            <Input v-model="formItem.roleName" placeholder="请输入名称"></Input>
          </FormItem>
          <FormItem label="权限字符">
            <Input
              v-model="formItem.roleKey"
              placeholder="请输入权限字符"
            ></Input>
            <div style="color: red">权限字符是权限组唯一标识</div>
          </FormItem>
          <FormItem label="绑定角色">
            <Select v-model="formItem.userIds" filterable multiple>
              <Option
                v-for="item in userListAll"
                :value="item.userId"
                :key="item.userId"
                >{{ item.nickName }}</Option
              >
            </Select>
          </FormItem>
          <FormItem label="默认权限">
            <i-switch
              v-model="formItem.isProtected"
              :trueValue="true"
              :falseValue="false"
            >
            </i-switch>
          </FormItem>
          <FormItem label="状态">
            <i-switch v-model="formItem.status" :trueValue="0" :falseValue="1">
            </i-switch>
          </FormItem>
          <FormItem label="备注">
            <Input
              v-model="formItem.remark"
              type="textarea"
              :autosize="{ minRows: 3 }"
              placeholder="请输入备注[可空]"
            ></Input>
          </FormItem>
          <form-header name="权限规则" label="选择合理的权限"></form-header>
          <FormItem label="勾选管理权限">
            <Tree
              ref="ruleTree"
              :data="ruletree"
              children-key="children"
              show-checkbox
              style="margin-top: -8px"
            ></Tree>
          </FormItem>
          <button-box>
            <button-sub @click="handleSubmit" :loading="sloading"></button-sub>
            <button-back></button-back>
          </button-box>
        </Form>
      </Col>
    </Row>
  </div>
</template>
<script>
import _ from "underscore";
export default {
  components: {},
  data() {
    return {
      index: 1,
      sloading: false,
      action: "add",
      mname: "role",
      url: {},
      kv: "",
      formItem: {
        status: 1,
        rules: "",
        roleSort: "0",
        userIds: [],
      },
      formRules: {
        name: [{ required: true, message: "名称不能为空", trigger: "blur" }],
      },
      ruletree: [],
      userListAll: [],
    };
  },
  async created() {
    let query = this.$route.query;
    this.action = query.action;
    this.loadUserList();
    if (query.action === "add") {
      // 添加初始化
      let ll1 = await this.getRules(2); // 获取管理权限树
      this.setTreeRule(ll1, []);
    } else if (query.action === "edit") {
      this.kv = query.kv;
      this.initData();
    } else {
      return $utils.toast.error("请求方式异常");
    }
  },
  methods: {
    async initData() {
      let id = this.kv;
      let res = await $utils.api.load(`/admin/system/role/${id}`, {});
      if (res && res.data) {
        this.formItem = res.data;
        this.formItem.status = Number(res.data.status) || 0;
        let arr = [];

        res.data.userList.forEach((item) => {
          arr.push(item.userId);
        });
        this.formItem.userIds = arr;
        let ll1 = await this.getRules(1); // 获取管理权限树
        this.setTreeRule(ll1.menus || [], ll1.checkedKeys || []);
      }
    },
    async loadUserList() {
      let q = {};
      let res = await $utils.api.load(
        "/admin/system/user/selectUserOptions",
        q,
        "get"
      );
      console.log(res);
      if (res.code == 200) {
        this.userListAll = res.data;
      }
    },
    handleSubmit() {
      // 管理权限
      const rr = this.$refs.ruleTree.getCheckedAndIndeterminateNodes();
      let rules = [];
      for (let i = 0; i < rr.length; i++) {
        const item = rr[i];
        rules.push(item.id);
      }
      this.formItem.menuIds = rules;
      this.$refs.form.validate((valid) => {
        if (valid) {
          $form.handleSubmit(this);
        }
      });
    },
    async getRules(pid) {
      // 通过pid查询权限规则树
      // 加载详情数据
      if (pid == 2) {
        let res = await $utils.api.load(`/admin/system/menu/treeselect`, {});
        if (res) {
          if (res.data) {
            return res.data;
          }
        }
        return;
      }
      let id = this.kv;
      let res = await $utils.api.load(
        `/admin/system/menu/roleMenuTreeselect/${id}`,
        {}
      );
      if (res) {
        if (res.menus) {
          let obj = {};
          obj.menus = res.menus;
          obj.checkedKeys = res.checkedKeys;
          return obj;
        }
      }
    },
    setTreeRule(tree, rules) {
      this._doRules(tree, rules);
      this.ruletree = tree;
    },
    _doRules(arr, rules) {
      for (let i = 0; i < arr.length; i++) {
        const item = arr[i];
        arr[i]["title"] = arr[i]["label"];
        // 判断子节点
        if (item.children && item.children.length > 0) {
          this._doRules(item.children, rules);
        }
        // 判断自身选中
        if (item.id && _.indexOf(rules, item.id) >= 0) {
          arr[i]["checked"] = true;
        }
      }
    },
  },
};
</script>
<style lang="less" scoped></style>
